import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Card, CardMedia, CardActionArea } from '@prisjakt/ui/card';
import Clickable from '@prisjakt/ui-clickable';
import {
  BodySmallText,
  CaptionText,
  Behavior,
  FontEmphasis,
  FontColor,
} from '@prisjakt/ui/text/variants';
import InfoList from '@prisjakt/ui-info-list';
import * as S from './styles';

type Props = {
  category?: {
    name: string;
    url: string;
  };
  className?: string;
  date?: string | null;
  grade?: React.ReactNode | null;
  onClick?: () => void;
  likes?: number | null;
  media?: React.ReactNode;
  style?: {};
  titleAndCategory: React.ReactNode;
  url: string;
  footer: React.ReactNode | null;
  footerPartOfLink?: boolean;
};

function ArticleCard({
  category,
  className,
  date,
  grade,
  onClick,
  likes,
  media,
  style,
  titleAndCategory,
  url,
  footer,
  footerPartOfLink = false,
}: Props) {
  const { renderMode, linkTo, t, market } = useContext(AppContext);

  const getInfoListItems = () => {
    const render = (string: string) => {
      return (
        <CaptionText emphasis={FontEmphasis.HIGH} color={FontColor.DARK}>
          {string}
        </CaptionText>
      );
    };
    const likesString =
      likes && likes >= 50
        ? t('expert', 'likes.count', {
            n: likes, // Only used for pluralisation
            count: likes.toLocaleString(market.locale),
          })
        : undefined;

    return [
      ...(date ? [render(date)] : []),
      ...(likesString ? [render(likesString)] : []),
    ];
  };

  const linkToString = linkTo(
    'expertContent',
    { semantic_id: url },
    renderMode === 'native' ? { view: 'native' } : undefined
  );

  return (
    <Card className={className} style={{ maxWidth: '100%', ...style }}>
      <CardActionArea
        container={Clickable}
        containerProps={{
          onClick,
          to: linkToString,
          isExternal: renderMode === 'native',
        }}
        style={{ flex: '1 0 auto' }}
      >
        {media && (
          <CardMedia>
            {grade}
            {media}
          </CardMedia>
        )}

        <S.Content>
          <S.Header>
            <BodySmallText
              behavior={Behavior.OnelineEllipsis}
              emphasis={FontEmphasis.MEDIUM}
            >
              {category && category.url && <>{category.name}</>}
            </BodySmallText>
          </S.Header>

          <S.Title>{titleAndCategory}</S.Title>

          <InfoList list={getInfoListItems()} />
        </S.Content>
        {footer && footerPartOfLink && <S.Footer>{footer}</S.Footer>}
      </CardActionArea>
      {footer && !footerPartOfLink && <S.Footer>{footer}</S.Footer>}
    </Card>
  );
}

export default ArticleCard;
